import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=4ef2a842&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=4ef2a842&prod&lang=scss&scoped=true"
import style1 from "./Toolbar.vue?vue&type=style&index=1&id=4ef2a842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2a842",
  null
  
)

export default component.exports